export const STRATS_TABLE_NA_LABEL = '-';
export const CURRENCY_USD_LABEL = '$';
export const SCROLL_TO_TABLE_ADDITIONAL_OFFSET_TOP = 70;

export const LABEL_FORMAT = {
  'Beginning Period': 'date',
  'Ending Period': 'date',
  'Total # of Leases': 'number',
  'Acquisition Cost (AC)': CURRENCY_USD_LABEL,
  'Rep. Period Securitization Value (SV)': CURRENCY_USD_LABEL,
  'Rep. Period End Actual SV (ESV)': CURRENCY_USD_LABEL,
  'Average BRV': CURRENCY_USD_LABEL,
  'As % of Rep. Period ESV:': 'string',
  'Consumer % / Commercial %': 'string',
  'WA Orginal Term (OT)': 'string',
  'WA Remaining Term (RT)': 'string',
  'WA Seasoning': 'string',
  'WA Credit Bureau Score (non-zero)': 'number',
  'WA Lease to Value (LTV)': '%',
  'Filters Applied': 'number',
  'Leases Excluded': 'number',
  'AC of Excluded Leases': CURRENCY_USD_LABEL,
  'ESV of Excluded Leases': CURRENCY_USD_LABEL,
  'Total Original # of Loans': 'number',
  'Total Original Loan Amount (OLA)': CURRENCY_USD_LABEL,
  'Weighted Average (WA) OLA': CURRENCY_USD_LABEL,
  'Rep. Period Beginning Loan Amount': CURRENCY_USD_LABEL,
  'Rep. Period Ending Loan Amount (ELA)': CURRENCY_USD_LABEL,
  'As % of Reporting Period ELA:': 'string',
  'New % / Used %': 'string',
  'WA Loan to Value (LTV)': '%',
  'WA Payment to Income (PTI)': '%',
  'WA Original APR': '%',
  'Loans Excluded': 'number',
  'OLA of Excluded Loans': CURRENCY_USD_LABEL,
  'ELA of Excluded Loans': CURRENCY_USD_LABEL,
  'Total Base Residual Value (BRV)': CURRENCY_USD_LABEL,
  'Base Residual as % of ESV': '%',
  'Base Residual as % of Vehicle Value': '%',
  'Minimum Discount Rate': '%',
};

export const PAGE_TITLE = 'StratMaker';

export const stratmakerNoAccessFeatures = [
  'Simplify setting up and cracking data tapes',
  '200+ advanced preset filters to quickly analyze asset composition & performance',
  'Drill down into underlying asset composition across transactions and issuers',
];

export const stratmakerNoAccessDescription = 'Use StratMaker, our propriety tool to instantly crunch through millions of data points and provide clean and consistent stratification tables for underlying asset & performance data across thousands of auto loan and lease transactions.';

export const stratmakerNoAccessImageCaption = 'Use 200+ advanced filters to browse loan-level data in a dynamic online pivot table.';
